import React from "react";

import { Check } from "icons";

export const ASSOCIATE_CDE_COLUMN = [
  {
    title: "CDE Name",
    key: "name",
    dataIndex: "name",
    width: "40%",
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "50%",
  },
  {
    title: "",
    key: "checked",
    dataIndex: "checked",
    render: text =>
      text && <Check size={15} style={{ color: "rgb(34, 118, 251)" }} />,
    width: "10%",
  },
];

export const ASSOCIATE_CDE_ROW = [
  {
    id: 1,
    cdeName: "First Name",
    description: "Provider Demographics",
  },
  {
    id: 2,
    cdeName: "Last Name",
    description: "Provider Demographics",
  },
  {
    id: 3,
    cdeName: "NPI",
    description: "Provider Group",
  },
  {
    id: 4,
    cdeName: "Address",
    description: "Patient Care",
  },
  {
    id: 5,
    cdeName: "Language",
    description: "Practitioner Language",
  },
];
